import { Helmet } from "react-helmet-async";

const DEFAULT_OG =
  "https://images.unsplash.com/photo-1764258560163-198782335017?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjeWJlciUyMGRhdGElMjBzdHJlYW0lMjBuZW9uJTIwZGFya3xlbnwwfHx8fDE3Nzc1MjM2NDl8MA&ixlib=rb-4.1.0&q=85";

const SITE = "https://unitedtechlab.com";
const DEFAULT_TITLE = "United Techlab | Enterprise IT Services & Products";
const DEFAULT_DESC =
  "United Techlab is a verification-first enterprise engineering partner, delivering application development, cloud, DevOps, legacy modernization, consulting, and enterprise AI observability.";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | United Techlab` : DEFAULT_TITLE;
  const canonical = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="United Techlab" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@jspeedluk" />
      <meta name="twitter:creator" content="@jspeedluk" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const OrgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "United Techlab",
  url: SITE,
  logo: `${SITE}/logo.png`,
  description: DEFAULT_DESC,
  sameAs: [
    "https://www.linkedin.com/in/jspeedluk/",
    "https://x.com/jspeedluk",
    "https://github.com/jspeedluk",
    "https://blog.unitedtechlab.com",
  ],
  founder: {
    "@type": "Person",
    name: "Kuldeep Singh Jangir",
    jobTitle: "Founder",
    email: "kuldeep@unitedtechlab.com",
    sameAs: [
      "https://www.linkedin.com/in/jspeedluk/",
      "https://x.com/jspeedluk",
      "https://github.com/jspeedluk",
    ],
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "contact@unitedtechlab.com",
      availableLanguage: ["English"],
    },
  ],
};
